import { message } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { api } from "../../services/api";
import { ButtonDecline } from "../ButtonDecline";
import { Status } from "../Status";
import { Content } from "./styles";

export interface IWhatsappConnectionInfo {
  status: string;
  name: string;
  number: string;
  createdAt: Date;
}
export function WhatsappConnectionInfo({
  status,
  name,
  number,
  createdAt,
  ...rest
}: IWhatsappConnectionInfo) {
  const [minutes, setMinutes] = useState(0);
  const [hours, setHours] = useState(0);
  const [days, setDays] = useState(0);
  function handleDisconnect() {
    api
      .post("whatsapp/disconnect")
      .then((response) => {
        console.log("true");
      })
      .catch((e) => {
        message.error(e.data.response.message);
      });
  }
  useEffect(()=>{
   const duration = moment.duration(moment().diff(createdAt))
   setMinutes(duration.minutes())
   setHours(duration.hours())
   setDays(duration.days())
  },[createdAt])
  return (
    <Content>
      <div className="details">
        <div className="left">
          <span>Nome:</span>
          <span>Número:</span>
          <span>Status:</span>
          <span>Tempo Conectado:</span>
        </div>
        <div className="right">
          <span>{name}</span>
          <span>{number}</span>
          <span>
            <Status title="ATIVO" type="ACTIVE" />
          </span>
          <span>{days}d {hours}h {minutes}m</span>
        </div>
      </div>
      <ButtonDecline title="Desconectar" onClick={handleDisconnect} />
    </Content>
  );
}
